import { EnvironmentFormData } from "./config";
import { EnvironmentValue } from "./types";

export function mapValueToFormValues(
  value: EnvironmentValue | null | undefined
): EnvironmentFormData {
  if (!value || typeof value !== "object") {
    return {
      aws: 0,
      gcp: 0,
      azure: 0,
      other: 0,
      onPrem: 0,
    };
  }
  return {
    aws: Number(value.aws) || 0,
    gcp: Number(value.gcp) || 0,
    azure: Number(value.azure) || 0,
    other: Number(value.other) || 0,
    onPrem: Number(value.onPrem) || 0,
  };
}

export function getEnvironmentPayload(
  formData: EnvironmentFormData
): EnvironmentValue {
  return {
    aws: formData.aws,
    gcp: formData.gcp,
    azure: formData.azure,
    other: formData.other,
    onPrem: formData.onPrem,
  };
}
